// extracted by mini-css-extract-plugin
export default {"form":"LogInModal_form__OfH0H","text":"LogInModal_text__wVbAM"};